import PropTypes from "prop-types";
import React from "react";
import { Accordion, Card, Tab, Tabs } from "react-bootstrap";
import Status from "../../../components/status-indicator/Status";
import Priority from "../../../components/priority/priority";
import ViewMembersPanelNew from "../../../components/view-members-new/view-members-new";
import ProgressPill from "../dashboard-shared/progress-pill/progress-pill";
import "../dashboard-healthcare/dashboard-healthcare.scss";

const DashboardEmailStatus = (props) => {
  const items = props.items;

  if (items != null) {
    return (
      <div className="new-dashboard table-wrapper">
        <div className="DashboardTableWrapper">
          <table>
            <thead>
              <tr className="DashboardTableHeader">
                <th className="DashboardTableTitle">
                  Email Tasks - Status Breakdown
                </th>
              </tr>
            </thead>
          </table>
          <div>
            <Accordion>
              <Card style={{ backgroundColor: "darkgray" }}>
                <Accordion.Toggle as={Card.Header}>
                  <div className="row">
                    <div
                      className="col-md-4 text-left"
                      style={{ color: "white" }}
                    >
                      Project Name
                    </div>
                    <div className="col-md-2" style={{ color: "white" }}>
                      Unopened
                    </div>
                    <div className="col-md-2" style={{ color: "white" }}>
                      Read
                    </div>
                    <div className="col-md-2" style={{ color: "white" }}>
                      Responded
                    </div>
                    <div className="col-md-1" style={{ color: "white" }}>
                      Completed
                    </div>
                  </div>
                </Accordion.Toggle>
              </Card>
              {items.map((m) => {
                return (
                  <Card className="noOverflow" key={m?.Id}>
                    <Accordion.Toggle as={Card.Header} eventKey={m.Id}>
                      <div className="row">
                        <div className="col-md-4 text-left">{m.Name}</div>
                        <div className="col-md-2">{m.EmailTasksUnread}</div>
                        <div className="col-md-2">{m.EmailTasksRead}</div>
                        <div className="col-md-2">{m.EmailTasksResponded}</div>
                        <div className="col-md-1">{m.EmailTasksComplete}</div>
                      </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={m.Id}>
                      <Card.Body>
                        <Tabs
                          defaultActiveKey={"home" + m.Id}
                          id={"projectsTasksDetails" + m.Id}
                          className="mb-3"
                        >
                          <Tab
                            eventKey={"home" + m.Id}
                            title={
                              "Unopened [" +
                              m.Tasks.filter(
                                (n) => n.StatusEmail === "Email Sent"
                              ).length +
                              "]"
                            }
                          >
                            <table>
                              <thead>
                                <tr>
                                  <th className="text-left pl-2">Task</th>
                                  <th>Status</th>
                                  <th>Last Activity</th>
                                  <th>Priority</th>
                                  <th className="text-left">Actionable By</th>
                                  <th className="text-left">Due Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                {m.Tasks.filter(
                                  (n) => n.StatusEmail === "Email Sent"
                                ).map((n) => {
                                  return (
                                    <tr key={n?.Id}>
                                      <td className="text-left pl-2">
                                        {n.Name}
                                      </td>
                                      <td>
                                        <Status
                                          status={n.Status}
                                          statusEmail={n.StatusEmail}
                                        />
                                      </td>
                                      <td>{n.LastActivityString}</td>
                                      <td>
                                        <Priority priority={n.Priority} />
                                      </td>
                                      <td className="text-left">
                                        <ViewMembersPanelNew
                                          taskType={n.TaskTypeId}
                                          UserID={n.CreatedById}
                                          members={n.Members}
                                        ></ViewMembersPanelNew>
                                      </td>
                                      <td className="text-left">
                                        <ProgressPill
                                          start={n.Added}
                                          end={n.DateDue}
                                          sortBy={"upcoming due dates"}
                                        />
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </Tab>
                          <Tab
                            eventKey={"profile" + m.Id}
                            title={
                              "Read [" +
                              m.Tasks.filter(
                                (n) => n.StatusEmail === "Email Read"
                              ).length +
                              "]"
                            }
                          >
                            <table>
                              <thead>
                                <tr>
                                  <th className="text-left pl-2">Task</th>
                                  <th>Status</th>
                                  <th>Last Activity</th>
                                  <th>Priority</th>
                                  <th className="text-left">Actionable By</th>
                                  <th className="text-left">Due Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                {m.Tasks.filter(
                                  (n) => n.StatusEmail === "Email Read"
                                ).map((n) => {
                                  return (
                                    <tr>
                                      <td className="text-left pl-2">
                                        {n.Name}
                                      </td>
                                      <td>
                                        <Status
                                          status={n.Status}
                                          statusEmail={n.StatusEmail}
                                        />
                                      </td>
                                      <td>{n.LastActivityString}</td>
                                      <td>
                                        <Priority priority={n.Priority} />
                                      </td>
                                      <td className="text-left">
                                        <ViewMembersPanelNew
                                          taskType={n.TaskTypeId}
                                          UserID={n.CreatedById}
                                          members={n.Members}
                                        ></ViewMembersPanelNew>
                                      </td>
                                      <td className="text-left">
                                        <ProgressPill
                                          start={n.Added}
                                          end={n.DateDue}
                                          sortBy={"upcoming due dates"}
                                        />
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </Tab>
                          <Tab
                            eventKey={"responded" + m.Id}
                            title={
                              "Responded [" +
                              m.Tasks.filter(
                                (n) => n.StatusEmail === "Email Response"
                              ).length +
                              "]"
                            }
                          >
                            <table>
                              <thead>
                                <tr>
                                  <th className="text-left pl-2">Task</th>
                                  <th>Status</th>
                                  <th>Last Activity</th>
                                  <th>Priority</th>
                                  <th className="text-left">Actionable By</th>
                                  <th className="text-left">Due Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                {m.Tasks.filter(
                                  (n) => n.StatusEmail === "Email Response"
                                ).map((n) => {
                                  return (
                                    <tr key={n?.Id}>
                                      <td className="text-left pl-2">
                                        {n.Name}
                                      </td>
                                      <td>
                                        <Status
                                          status={n.Status}
                                          statusEmail={n.StatusEmail}
                                        />
                                      </td>
                                      <td>{n.LastActivityString}</td>
                                      <td>
                                        <Priority priority={n.Priority} />
                                      </td>
                                      <td className="text-left">
                                        <ViewMembersPanelNew
                                          taskType={n.TaskTypeId}
                                          UserID={n.CreatedById}
                                          members={n.Members}
                                        ></ViewMembersPanelNew>
                                      </td>
                                      <td className="text-left">
                                        <ProgressPill
                                          start={n.Added}
                                          end={n.DateDue}
                                          sortBy={"upcoming due dates"}
                                        />
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </Tab>
                          <Tab
                            eventKey={"completed" + m.Id}
                            title={
                              "Completed [" +
                              m.Tasks.filter((n) => n.StatusEmail === null)
                                .length +
                              "]"
                            }
                          >
                            <table>
                              <thead>
                                <tr>
                                  <th className="text-left pl-2">Task</th>
                                  <th>Status</th>
                                  <th>Last Activity</th>
                                  <th>Priority</th>
                                  <th className="text-left">Actionable By</th>
                                  <th className="text-left">Due Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                {m.Tasks.filter(
                                  (n) => n.StatusEmail == null
                                ).map((n) => {
                                  return (
                                    <tr key={n?.Id}>
                                      <td className="text-left pl-2">
                                        {n.Name}
                                      </td>
                                      <td>
                                        <Status
                                          status={n.Status}
                                          statusEmail={n.StatusEmail}
                                        />
                                      </td>
                                      <td>{n.LastActivityString}</td>
                                      <td>
                                        <Priority priority={n.Priority} />
                                      </td>
                                      <td className="text-left">
                                        <ViewMembersPanelNew
                                          taskType={n.TaskTypeId}
                                          UserID={n.CreatedById}
                                          members={n.Members}
                                        ></ViewMembersPanelNew>
                                      </td>
                                      <td className="text-left">
                                        <ProgressPill
                                          start={n.Added}
                                          end={n.DateDue}
                                          sortBy={"upcoming due dates"}
                                        />
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </Tab>
                        </Tabs>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                );
              })}
            </Accordion>
          </div>
        </div>
      </div>
    );
  }
  return null;
};

DashboardEmailStatus.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
};

export default DashboardEmailStatus;
